
import { Options, Vue } from "vue-class-component";

export interface ICookieConsent {
  state: boolean;
  consent: boolean;
}

@Options({
  components: {
  },
  props: {
    
  }
})
export default class CookieConsent extends Vue {
  consent: ICookieConsent = {
    state: false,
    consent: false
  };

  get show() : boolean {
    return !(this.consent?.state ?? false);
  }

  mounted() {
    this.load();
  }

  submit(value: boolean) {
    this.consent = {
      state: true,
      consent: value
    };

    this.save();
  }

  load() {
    const consentRaw = localStorage.getItem('cookie-consent');
    if (!consentRaw)
      return;

    this.consent = JSON.parse(consentRaw);
  }

  save() {
    if (!this.consent)
      return;

    localStorage.setItem('cookie-consent', JSON.stringify(this.consent))
  }
}
